"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Slider = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const styles = __importStar(require("./slider.module.scss"));
const sqrLength = (a, b) => {
    const length = Math.pow(a[0] - b[0], 2) + Math.pow(a[1] - b[1], 2);
    return length;
};
const Slider = ({ options, onChange, value, hasError, showMiddleLabel, showLabelForSelectedValue, children, naTitles, naValues, ignoreTitles, ignoreValues, valueIncludeNA, }) => {
    const minLabel = (0, react_1.useMemo)(() => { var _a; return (_a = options[0]) === null || _a === void 0 ? void 0 : _a.title; }, [options]);
    const maxLabel = (0, react_1.useMemo)(() => { var _a; return (_a = options[options.length - 1]) === null || _a === void 0 ? void 0 : _a.title; }, [options]);
    const middleLabel = (0, react_1.useMemo)(() => { var _a; return showMiddleLabel && ((_a = options[Math.floor(options.length / 2)]) === null || _a === void 0 ? void 0 : _a.title); }, [options]);
    const initialValue = (0, react_1.useMemo)(() => {
        return value == null ? Math.floor(options.length / 2) : value;
    }, [value, options]);
    const lastMousePosition = react_1.default.useRef(undefined);
    const labelForSelectedValue = (0, react_1.useMemo)(() => {
        var _a, _b;
        // naValuesが選択された場合の表示
        if (valueIncludeNA && naValues) {
            const foundNaValue = naValues.find((naValue, index) => {
                return valueIncludeNA === naValue;
            });
            if (foundNaValue != null) {
                const index = naValues.indexOf(foundNaValue);
                return (naTitles === null || naTitles === void 0 ? void 0 : naTitles[index]) || foundNaValue.toString();
            }
        }
        // ignoreValuesが選択された場合の表示
        if (valueIncludeNA && ignoreValues) {
            const foundIgnoreValue = ignoreValues.find((ignoreValue, index) => {
                return valueIncludeNA === ignoreValue;
            });
            if (foundIgnoreValue != null) {
                const index = ignoreValues.indexOf(foundIgnoreValue);
                return (ignoreTitles === null || ignoreTitles === void 0 ? void 0 : ignoreTitles[index]) || foundIgnoreValue.toString();
            }
        }
        return value != null
            ? showLabelForSelectedValue
                ? (_a = options[value]) === null || _a === void 0 ? void 0 : _a.title
                : (_b = options[value]) === null || _b === void 0 ? void 0 : _b.value
            : "未選択";
    }, [
        value,
        valueIncludeNA,
        options,
        showLabelForSelectedValue,
        naTitles,
        naValues,
        ignoreTitles,
        ignoreValues,
    ]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.range__wrapper, hasError && styles.range__wrapper__error) },
        react_1.default.createElement("div", { className: styles.range__label__top },
            react_1.default.createElement("span", null, minLabel),
            react_1.default.createElement("span", null, maxLabel)),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.range, hasError && styles.range__error) },
            react_1.default.createElement("input", { type: "range", className: (0, classnames_1.default)(styles.range__input, value == null && styles.range__input__unselected, hasError && styles.range__input__error), value: initialValue, min: 0, max: options.length - 1, step: 1, onChange: (e) => {
                    const index = parseInt(e.target.value);
                    onChange(index);
                }, onMouseDown: (e) => {
                    lastMousePosition.current = {
                        x: e.clientX,
                        y: e.clientY,
                        index: parseInt(e.currentTarget.value),
                    };
                }, onMouseUp: (e) => {
                    var _a;
                    const currentMousePosition = [e.clientX, e.clientY];
                    const mouseNotMoved = lastMousePosition.current &&
                        sqrLength([lastMousePosition.current.x, lastMousePosition.current.y], currentMousePosition) < 10;
                    const newIndex = parseInt(e.currentTarget.value);
                    const indexChanged = ((_a = lastMousePosition.current) === null || _a === void 0 ? void 0 : _a.index) !== newIndex;
                    if (mouseNotMoved && !indexChanged) {
                        if (value == null) {
                            onChange(Math.floor(options.length / 2));
                        }
                        else {
                            onChange(undefined);
                        }
                    }
                    lastMousePosition.current = undefined;
                } })),
        react_1.default.createElement("div", { className: styles.range__label__bottom },
            react_1.default.createElement("span", null, middleLabel)),
        children,
        react_1.default.createElement("div", null,
            react_1.default.createElement("span", { className: (0, classnames_1.default)(styles.range__label__selected, value == null && !valueIncludeNA && styles.range__input__unselected) }, (typeof labelForSelectedValue === "string" ||
                typeof labelForSelectedValue === "number") &&
                labelForSelectedValue))));
};
exports.Slider = Slider;
